import { Action } from 'typescript-fsa';
import * as actions from './actions';
import { Dispatch } from 'redux';

const startLoading = () => (dispatch: Dispatch<Action<any>>) => {
  dispatch(actions.loading.started({}));
};
const stopLoading = () => (dispatch: Dispatch<Action<any>>) => {
  dispatch(actions.loading.done({ params: {}, result: {}}));
};

export { startLoading, stopLoading };



// WEBPACK FOOTER //
// ./src/redux/modules/loading/operations.ts